import React, { useState } from "react";
import {
	Tab,
	Input,
	Form,
	Table,
	Dropdown,
	Button,
	Divider,
	Checkbox,
	Confirm,
	Popup,
	Label,
	Icon,
	TextArea,
	Modal
} from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import {
	getSurveyPeriods,
	submitSurveyData,
	getSurveyData,
	surveyDataUpdate,
	clearInfoAndErrorMessages,
	selectNewYear
} from "./DynamicSurveyActions.js";
import EstablishmentsContainer from "./establishments/EstablishmentsContainer.js";
import { schemaJsonMetamodel, possibleFieldTypes } from "./DynamicSurveyActions";
import { allFieldsWithReferences } from "./DynamicSurveyReducer.js";
import { calculateFormula } from "./DynamicSurveyReducer.js";
import "moment/locale/ar";
import "moment/locale/en-ca";
import moment from "moment";
import SurveyInfoModal from "./survey-info-modal/SurveyInfoModal.js";
import { Prompt } from "react-router";
import MessageModal from "../../common/message/MessageModal.jsx";
import {selectSurveyEstablishment} from "./establishments/EstablishmentsActions";

const surveyState = {
	SIGNED: "S",
	MODIFIED: "M",
	APPROVED: "A",
	REJECTED: "R"
};

const userType = {
	STANDARD: "S",
	ADMIN: "A"
};

const DynamicForm = ({
	schemaJsonMetamodel,
	form,
	parentKey,
	root,
	t,
	handleInput,
	values,
	loginData,
	activeLangCode,
	disabled,
	hideForm
}) => {
	let generatedForm = form
		.filter(x => !x.hidden && !hideForm)
		.map((fieldRow, index) => {
			if (Array.isArray(fieldRow)) {
				if (!Array.isArray(fieldRow[0])) {
					return (
						<FieldGroup
							key={parentKey + index}
							parentKey={parentKey + index}
							fields={fieldRow}
							handleInput={handleInput}
							values={values}
							t={t}
							loginData={loginData}							
							schemaJsonMetamodel={schemaJsonMetamodel}
							activeLangCode={activeLangCode}
							disabled={disabled}
						/>
					);
				} else {
					return (
						<FieldTable
							key={parentKey + index}
							parentKey={parentKey + index}
							fields={fieldRow}
							handleInput={handleInput}
							values={values}
							t={t}
							schemaJsonMetamodel={schemaJsonMetamodel}
							activeLangCode={activeLangCode}
							disabled={disabled}
						/>
					);
				}
			} else {
				if (fieldRow.type === "display") {
					return (
						<Form.Group key={parentKey + index} inline>
							<SimpleLabel
								value={fieldRow.lang[activeLangCode]}
							/>
						</Form.Group>
					);
				}
				return (
					<Form.Group key={parentKey + index} inline>
						<SimpleField
							field={fieldRow}
							handleInput={handleInput}
							 
							values={values}
							t={t}
							schemaJsonMetamodel={schemaJsonMetamodel}
							loginData={loginData}
							activeLangCode={activeLangCode}
							disabled={disabled}
						/>
					</Form.Group>
				);
			}
		});
	return generatedForm;
};

const SimpleLabel = ({ value }) => {
	return (
		<Form.Field>
			<label dangerouslySetInnerHTML={{ __html: value + " " }} />
		</Form.Field>
	);
};

const CalculatedInputSum = ({ field, values, activeLangCode }) => {
	return (
		<Popup
			disabled={!values[field.name]}
			trigger={
				<span>
					<Input
						disabled
						name={field.name}
						style={{
							width: field.length
								? field.length * 6.5 || 0 + "px"
								: field.type && field.type === "smallint"
								? "120px"
								: "auto"
						}}
						type="text"
						value={
							values[field.name] !== null &&
							values[field.name] !== undefined
								? typeof values[field.name] === "object"
									? values[field.name].lang[activeLangCode]
									: values[field.name]
								: ""
						}
						className="no-border-radius"
					/>
				</span>
			}
		>
			{values[field.name] !== null && values[field.name] !== undefined
				? typeof values[field.name] === "object"
					? values[field.name].lang[activeLangCode]
					: values[field.name]
				: ""}
		</Popup>
	);
};

const ComboboxInput = ({
	schemaJsonMetamodel,
	field,
	values,
	t,
	handleInput,
	modelValue,
	activeLangCode,
	disabled
}) => {
	const [focus, setFocus] = useState(false);

	let optionValues = [];
	if (Array.isArray(values)) {
		optionValues = values.map(x => ({
			key: x[0],
			value: x[0],
			text: x[2].lang[activeLangCode]
		}));
	} else if (typeof values === "string" && values !== "parent") {
		if (!focus) {
			return (
				<Dropdown
					open={false}
					onOpen={() => setFocus(true)}
					search
					disabled={disabled}
					basic
					selection
					lazyLoad={true}
					placeholder={t("select")}
					value={modelValue[field.name] ? modelValue[field.name] : ""}
					options={
						modelValue[field.name]
							? schemaJsonMetamodel.lookup[values]
									.filter(
										x => x.value === modelValue[field.name]
									)
									.map(x => ({ ...x, text: x.value }))
							: []
					}
					onChange={handleInput}
					className="no-border-radius"
					name={field.name}
					clearable={
						modelValue[field.name] &&
						schemaJsonMetamodel.lookup[values] &&
						schemaJsonMetamodel.lookup[values].filter(
							x => x.lang[activeLangCode] === ""
						).length === 0
							? true
							: false
					}
				/>
			);
		}
		if (focus) {
			optionValues = schemaJsonMetamodel.lookup[values].map(x => ({
				...x,
				text:
					x.key !== ""
						? x.key + " (" + x.lang[activeLangCode] + ")"
						: ""
			}));
			return (
				<Dropdown
					open={true}
					onClose={() => setFocus(false)}
					search
					disabled={disabled}
					basic
					selection
					lazyLoad={true}
					placeholder={t("select")}
					options={optionValues}
					onChange={handleInput}
					 
					value={modelValue[field.name] ? modelValue[field.name] : ""}
					name={field.name}
					className="no-border-radius"
					clearable={
						modelValue[field.name] &&
						optionValues &&
						optionValues.filter(x => x.lang[activeLangCode] === "")
							.length === 0
							? true
							: false
					}
				/>
			);
		}
	}

	return (
		<Dropdown
			search
			basic
			selection
			lazyLoad={true}
			placeholder={t("select")}
			options={optionValues}
			className="no-border-radius"
			onChange={handleInput}
			 
			name={field.name}
			value={modelValue[field.name] ? modelValue[field.name] : ""}
			clearable={
				modelValue[field.name] &&
				optionValues &&
				optionValues.filter(x => x.text === "").length === 0
					? true
					: false
			}
			disabled={disabled}
		/>
	);
};

const SimpleField = ({
	schemaJsonMetamodel,
	field,
	handleInput,
	values,
	t, 
	loginData,
	activeLangCode,
	disabled
}) => {
	return (
		<React.Fragment>
			<Form.Field>
				{field.lang && field.type !== possibleFieldTypes.BOOLEAN && (
					<label>{field.lang[activeLangCode]}</label>
				)}
				{(field.type === possibleFieldTypes.CALCULATED ||
					field.type === possibleFieldTypes.CALCULATED_LATER ||
					field.type === possibleFieldTypes.LOOKUP) && (
					<CalculatedInputSum
						type="number"
						field={field}
						values={values}
						activeLangCode={activeLangCode}
					/>
				)}
				{field.type === possibleFieldTypes.BOOLEAN && (
					<Checkbox
						label={field.lang[activeLangCode]}
						checked={values[field.name] === 1}
						name={field.name}
						onChange={handleInput}
						 
						className="no-border-radius"
						disabled={disabled}
					/>
				)}
				{field.type !== possibleFieldTypes.BOOLEAN &&
					field.type !== possibleFieldTypes.CALCULATED &&
					field.type !== possibleFieldTypes.CALCULATED_LATER &&
					field.type !== possibleFieldTypes.LOOKUP &&
					!field.lookup && (
						<Input
							type={
								field.type === possibleFieldTypes.STRING
									? "text"
									: "number"
							}
							name={field.name}
							style={{
								width: field.length
									? field.length * 7 || 0 + "px"
									: field.type && field.type === "smallint"
									? "120px"
									: "auto"
							}}
							onChange={handleInput}
							disabled={
								(field.admin &&
									field.admin === "yes" && 
									loginData.type === userType.STANDARD) ||
								disabled
							}
							 
							value={
								values[field.name] !== null &&
								values[field.name] !== undefined
									? values[field.name]
									: ""
							}
							className="no-border-radius"
						/>
					)}
				{field.lookup && (
					<ComboboxInput
						field={field}
						values={field.lookup.values}
						schemaJsonMetamodel={schemaJsonMetamodel}
						handleInput={handleInput}
						t={t} 
						modelValue={values}
						activeLangCode={activeLangCode}
						disabled={
							(field.admin &&
								field.admin === "yes" && 
								loginData.type === userType.STANDARD) ||
							disabled
						}
					/>
				)}
			</Form.Field>
		</React.Fragment>
	);
};

const FieldGroup = ({
	schemaJsonMetamodel,
	fields,
	parentKey,
	handleInput,
	t, 
	values,
	activeLangCode,
	loginData,		
	disabled
}) => {
	let generatedForm = fields
		.filter(x => !x.hidden)
		.map((fieldRow, index) => {
			if (fieldRow.type === "display") {
				return (
					<SimpleLabel
						key={parentKey + index}
						value={fieldRow.lang[activeLangCode]}
					/>
				);
			}
			return (
				<SimpleField
					key={parentKey + index}
					field={fieldRow}
					handleInput={handleInput}
					t={t} 
					values={values}
					schemaJsonMetamodel={schemaJsonMetamodel}
					activeLangCode={activeLangCode}
					loginData={loginData}						
					disabled={disabled}
				/>
			);
		});
	return <Form.Group inline>{generatedForm}</Form.Group>;
};

const FieldTable = ({
	schemaJsonMetamodel,
	fields,
	parentKey,
	handleInput,
	t, 
	values,
	activeLangCode,
	disabled
}) => {
	let generatedForm = fields
		.filter(x => !x.hidden)
		.map((fieldRow, index) => {
			return (
				<Table.Row key={parentKey + index} className="no-border">
					{fieldRow.map((fieldCell, index2) => {
						if (fieldCell.type === "display") {
							return (
								<Table.Cell key={parentKey + index + index2}>
									<SimpleLabel
										value={fieldCell.lang[activeLangCode]}
									/>
								</Table.Cell>
							);
						}
						return (
							<Table.Cell
								key={parentKey + index + index2}
								style={{ padding: 0 }}
							>
								<SimpleField
									field={fieldCell}
									handleInput={handleInput}
									t={t} 
									values={values}
									schemaJsonMetamodel={schemaJsonMetamodel}
									activeLangCode={activeLangCode}
									disabled={disabled}
								/>
							</Table.Cell>
						);
					})}
				</Table.Row>
			);
		});
	return (
		<Table compact basic="very" collapsing>
			<Table.Body>{generatedForm}</Table.Body>
		</Table>
	);
};

class DynamicSurveyComponent extends React.Component {
	constructor(props) {
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.submitData = this.submitData.bind(this);
		this.checkValidationForCalculatedValue = this.checkValidationForCalculatedValue.bind(
			this
		);
		this.checkLongitude = this.checkLongitude.bind(this);
		this.checkLatitude = this.checkLatitude.bind(this);

		this.state = {
			isOpenConfirmSubmit: false,
			isOpenConfirmSign: false,
			isOpenConfirmApprove: false,
			isOpenConfirmReject: false,
			visibleSurveyModal: true,
			unsavedForm: false,
			rejectReasonText: "",
			showMessage: false,
			message: "",
			positiveMessage: false,
			negativeMessage: false,
			warningMessage: false,
			reasonMessageViewed : false,
			selectedYear: props.selectedYear
		};
		this.openConfirmSubmit = this.openConfirmSubmit.bind(this);
		this.openConfirmSign = this.openConfirmSign.bind(this);
		this.openConfirmApprove = this.openConfirmApprove.bind(this);
		this.openConfirmReject = this.openConfirmReject.bind(this);
		this.closeConfirmSubmit = this.closeConfirmSubmit.bind(this);
		this.closeConfirmSign = this.closeConfirmSign.bind(this);
		this.closeConfirmApprove = this.closeConfirmApprove.bind(this);
		this.closeConfirmReject = this.closeConfirmReject.bind(this);
		this.closeSurveyModal = this.closeSurveyModal.bind(this);
		this.onBrowserTabClose = this.onBrowserTabClose.bind(this);
		this.unsavedFormClear = this.unsavedFormClear.bind(this);
		this.rejectReasonChanged = this.rejectReasonChanged.bind(this);
		this.rejectData = this.rejectData.bind(this);
		this.closeMessageModal = this.closeMessageModal.bind(this);
		this.selectedYearChanged = this.selectedYearChanged.bind(this);
	}

	closeMessageModal() {
		this.setState({
			...this.state,
			showMessage: false,
			message: "",
			positiveMessage: false,
			negativeMessage: false,
			warningMessage: false
		});
	}

	openConfirmSubmit() {
		this.setState({ ...this.state, isOpenConfirmSubmit: true });
	}

	openConfirmSign() {
		this.setState({ ...this.state, isOpenConfirmSign: true });
	}

	rejectReasonChanged(event) {
		this.setState({ ...this.state, rejectReasonText: event.target.value });
	}

	selectedYearChanged(event, data) {
		const { t } = this.props;
		if (this.state.unsavedForm) {
			if (window.confirm(t("confirmSelect"))) {
				this.setState({ ...this.state, selectedYear: data.value });
				this.props.dispatch(selectNewYear(data.value ));
				this.setState({ ...this.state, unsavedForm: false });
			}
			else {
				event.target.value = data.value = 	this.props.selectedYear;
			}
		} else {
			this.setState({ ...this.state, selectedYear: data.value });
			this.props.dispatch(selectNewYear(data.value ));
		}
	}


	openConfirmApprove() {
		this.setState({ ...this.state, isOpenConfirmApprove: true });
	}

	openConfirmReject() {
		this.setState({ ...this.state, isOpenConfirmReject: true });
	}

	closeConfirmSubmit() {
		this.setState({ ...this.state, isOpenConfirmSubmit: false });
	}

	closeConfirmSign() {
		this.setState({ ...this.state, isOpenConfirmSign: false });
	}

	closeConfirmApprove() {
		this.setState({ ...this.state, isOpenConfirmApprove: false });
	}

	closeConfirmReject() {
		this.setState({ ...this.state, isOpenConfirmReject: false });
	}

	onBrowserTabClose(event) {
		const { t } = this.props;
		if (this.state.unsavedForm) {
			event.returnValue = t("confirmLeave");
		}
	}

	componentDidMount() {
		this.props.getSurveyPeriods();
		window.addEventListener("beforeunload", this.onBrowserTabClose);
	}

	componentWillUnmount() {
		window.removeEventListener("beforeunload", this.onBrowserTabClose);
	}

	unsavedFormClear() {
		this.setState({ ...this.state, unsavedForm: false });
	}

	handleInput(event, data) {
		let name = event.target.name;
		let value = event.target.value;

		if (data) {
			name = data.name;
			if (data.type === "checkbox") {
				value = data.checked ? 1 : 0;
			} else {
				value = data.value;
			}
		} else {
			name = event.target.name;
			value = event.target.value;
		}

		let valuesFromState = { ...this.props.surveyData.mappedFields };


		valuesFromState[name] =
			event.target.type === "number"
				? value && value !== ""
					? Number(value)
					: null
				: value;
		this.props.dispatch(surveyDataUpdate(valuesFromState, name));
		this.setState({ ...this.state, unsavedForm: true });
	}

	/**
	 * 
	 * @param {submit/approve/sign} type 
	 * @param {active tab panel} tabName 
	 */
	submitData(type, tabName) {
		const { t } = this.props;
		this.setState(
			{
				...this.state,
				isOpenConfirmSubmit: false,
				isOpenConfirmSign: false,
				isOpenConfirmApprove: false,
				isOpenConfirmReject: false
			},
			() => {
				/**
				 * either all tab panels or only the current one
				 */

				let allFieldsKeys = (!(type === "submit") || !tabName) ? 
					Object.keys(allFieldsWithReferences) :
						Object.values(allFieldsWithReferences).map( x => ({name: x.name, tabname: x.tabname})).filter(x => x.tabname && x.tabname.charAt(0) === tabName.charAt(0)).map(x=>x.name);



				let loginData = { ...this.props.loginData };


				for (let i = 0; i < allFieldsKeys.length; i++) {
					let referencedField = allFieldsKeys[i];

					if (
						allFieldsWithReferences[referencedField].check ||
						allFieldsWithReferences[referencedField].formula_range
					) {
						let validationResult = this.checkValidationForCalculatedValue(
							this.props.surveyData.mappedFields,
							allFieldsWithReferences[referencedField],
							this.props.surveyData.mappedFields[referencedField]
						);
						if (!validationResult.valueIsValid) {
							return;
						}
					}

					/**
							  * deal with this:
								  "admin": "yes",
								  "required" : "admin"    
									  	
								  and this
						  	
								  "required" : "standard"
							  */

					let value = this.props.surveyData.mappedFields[
						referencedField
					];

					if (
						!value &&
						(allFieldsWithReferences[referencedField].required ===
							"yes" ||
							(loginData.type === userType.ADMIN &&
								allFieldsWithReferences[referencedField]
									.required === "admin") ||
							(loginData.type === userType.STANDARD &&
								allFieldsWithReferences[referencedField]
									.required === "standard"))
					) {
						this.setState({
							...this.state,
							message:
								allFieldsWithReferences[referencedField].lang[
									this.props.activeLangCode
								] +
								" " +
								t("isMandatory"),
							showMessage: true,
							negativeMessage: true
						});
						return;
					}


						if (allFieldsWithReferences[referencedField].range) {
							let value = this.props.surveyData.mappedFields[referencedField];
							let numValue = Number(this.props.surveyData.mappedFields[referencedField]);
							if (
								value &&
								(numValue < allFieldsWithReferences[referencedField].range[0] ||
									numValue > allFieldsWithReferences[referencedField].range[1])
							) {
								this.setState({
									...this.state,
									message:
									referencedField +
										" " +
										t("valueInRange") +
										"=" +
										value +
										" " +
										t("mustBeInRange") +
										"[" +
										allFieldsWithReferences[referencedField].range[0] +
										", " +
										allFieldsWithReferences[referencedField].range[1] +
										"].",
									showMessage: true,
									negativeMessage: true
								});
								return;
							}
						}


					if (
						allFieldsWithReferences[referencedField].type ===
						possibleFieldTypes.LONGITUDE
					) {
						if (
							!this.checkLongitude(
								allFieldsWithReferences[referencedField].lang
									.en,
								this.props.surveyData.mappedFields[
									referencedField
								]
							)
						) {
							return;
						}
					} else if (
						allFieldsWithReferences[referencedField].type ===
						possibleFieldTypes.LATITUDE
					) {
						if (
							!this.checkLatitude(
								allFieldsWithReferences[referencedField].lang
									.en,
								this.props.surveyData.mappedFields[
									referencedField
								]
							)
						) {
							return;
						}
					}
					//check the field sizes by first checking if maxlength exists and if not, then the size
					else if (
						allFieldsWithReferences[referencedField].type ===
						possibleFieldTypes.STRING
					) {
						if (
							allFieldsWithReferences[referencedField]
								.maxlength && this.props.surveyData.mappedFields[referencedField] && 
							allFieldsWithReferences[referencedField].maxlength <
								this.props.surveyData.mappedFields[
									referencedField
								].length
						) {
							this.setState({
								...this.state,
								message:
									allFieldsWithReferences[referencedField]
										.lang[this.props.activeLangCode] +
									" " +
									t("sizeIzGreaterThen") +
									" " +
									allFieldsWithReferences[referencedField]
										.maxlength,
								showMessage: true,
								negativeMessage: true
							});
							return;
						} else if (
							this.props.surveyData.mappedFields[
								referencedField
							] && allFieldsWithReferences[referencedField].maxlength === undefined && 
							allFieldsWithReferences[referencedField].length <
								this.props.surveyData.mappedFields[
									referencedField
								].length
						) {
							this.setState({
								...this.state,
								message:
									allFieldsWithReferences[referencedField]
										.lang[this.props.activeLangCode] +
									" " +
									t("sizeIzGreaterThen") +
									" " +
									allFieldsWithReferences[referencedField]
										.length,
								showMessage: true,
								negativeMessage: true
							});
							return;
						}
					}
				}

				let keys = allFieldsKeys //Object.keys(this.props.surveyData.mappedFields);
				let inputFields = keys
					.map(x => ({
						name: x,
						value: this.props.surveyData.mappedFields[x]
					}))
					.filter(x => (type === "submit") &&
							!(typeof x.value === "undefined") &&  //labels do not go to the backedn
								!(typeof x.value === "object" && x.value !== null)) //not null complex objects do not go to the backend
		
				let dataRequest = {
					year: this.props.selectedYear,
					fields: inputFields
				};
		
				if (this.props.loginData.type === userType.ADMIN) {
					let selected = this.props.establishments.filter(
						x => x.selected
					);
					if (selected && selected[0] && selected[0].search_id) {
						dataRequest.searchId = selected[0].search_id;
					} else {
						this.setState({
							...this.state,
							message: t("selectEstablishment"),
							showMessage: true,
							negativeMessage: true
						});
						return;
					}
				} else {
					dataRequest.searchId = this.props.loginData.searchId;
				}
				this.props.submitSurveyDataDispatch(dataRequest, type);
				this.setState({ ...this.state, unsavedForm: false });		
			}
		);
	}



	checkLongitude(name, value) {
		const { t } = this.props;
		if (value) {
			if (!Number.isFinite(value) || Math.abs(value > 180)) {
				this.setState({
					...this.state,
					message: name + " " + t("longitudeMessage"),
					showMessage: true,
					negativeMessage: true
				});
				return false;
			}
		}
		return true;
	}

	checkLatitude(name, value) {
		const { t } = this.props;
		if (value) {
			if (!Number.isFinite(value) || Math.abs(value > 90)) {
				this.setState({
					...this.state,
					message: name + " " + t("latitudeMessage"),
					showMessage: true,
					negativeMessage: true
				});
				return false;
			}
		}
		return true;
	}

	checkValidationForCalculatedValue(valuesFromState, calculatedField, value) {
		let validationResult = {};
		validationResult.valueIsValid = true;
		validationResult.message = "";

		if (calculatedField.formula_range) {
			if (calculatedField.formula_range.range) {
				let calculatedValueForRangeCheck = calculateFormula(
					calculatedField.formula_range.formula,
					valuesFromState
				);

				if (
					calculatedValueForRangeCheck !== 0 &&
					calculatedValueForRangeCheck !== null
				) {
					let lower = calculatedField.formula_range.range[0];
					let upper = calculatedField.formula_range.range[1];

					if (
						calculatedValueForRangeCheck < lower ||
						((upper !== "infinite") && calculatedValueForRangeCheck > upper)
					) {
						this.setState({
							...this.state,
							message:
								calculatedField.formula_range.lang[
									this.props.activeLangCode
								],
							showMessage: true,
							negativeMessage: true
						});
						validationResult.valueIsValid = false;
						validationResult.message =
							calculatedField.formula_range.lang[
								this.props.activeLangCode
							];
					}
				}
			}

			return validationResult;
		}

		switch (calculatedField.check.type) {
			case "equals":
			case "greater_than":
				let value1 = value == null ? 0 : value;

				if (calculatedField.check.if_not_zero && value1 === 0) break;

				let value2 = calculatedField.check.is_value
					? Number(calculatedField.check.compare_with)
					: valuesFromState[calculatedField.check.compare_with];

				value2 = value2 == null ? 0 : value2;

				if (calculatedField.check.type === "equals")
					validationResult.valueIsValid = value1 === value2;
				else validationResult.valueIsValid = value1 > value2;

				if (!validationResult.valueIsValid) {
					validationResult.valueIsValid = false;
					validationResult.message =
						calculatedField.check.lang[this.props.activeLangCode];
					this.setState({
						...this.state,
						message:
							calculatedField.check.lang[
								this.props.activeLangCode
							],
						showMessage: true,
						negativeMessage: true
					});
				}

				break;

			case "not_zero":
				value1 = value == null ? 0 : value;

				if (value1 <= 0) {
					validationResult.valueIsValid = false;
					validationResult.message =
						calculatedField.check.lang[this.props.activeLangCode];
					this.setState({
						...this.state,
						message:
							calculatedField.check.lang[
								this.props.activeLangCode
							],
						showMessage: true,
						negativeMessage: true
					});
				}

				break;
			default: alert("Unsupported calculation type=" + calculatedField.check.type + " received in " + calculatedField);	
		}

		return validationResult;
	}

	closeSurveyModal() {
		this.setState({ ...this.state, visibleSurveyModal: false });
	}

	rejectData() {
		const { t } = this.props;
		let dataRequest = {
			year: this.state.selectedYear ? this.state.selectedYear : this.props.years[0].year,
			reasonMessage: this.state.rejectReasonText
		};

		if (this.props.loginData.type === userType.ADMIN) {
			let selected = this.props.establishments.filter(x => x.selected);
			if (selected && selected[0] && selected[0].search_id) {
				dataRequest.searchId = selected[0].search_id;
			} else {
				this.setState({
					message: t("selectEstablishment"),
					showMessage: true,
					negativeMessage: true
				});
				return;
			}
		} else {
			dataRequest.searchId = this.props.loginData.searchId;
		}
		this.props.submitSurveyDataDispatch(dataRequest, "reject");
		this.setState({
			...this.state,
			rejectReasonText: "",
			isOpenConfirmReject: false
		});
	}

	render() {
		const { t } = this.props;

		if (!this.props.surveyData || !this.props.surveyData.mappedFields) {
			return null;
		}

		let panes = [
			schemaJsonMetamodel.register,
			...schemaJsonMetamodel.sections
		].map(section => ({
			menuItem: section.lang[this.props.activeLangCode],
			render: () => (
				<Tab.Pane
					dir={this.props.activeLangCode === "ar" ? "rtl" : "ltr"}
					compact
					basic
					key={section.lang[this.props.activeLangCode]}
				>

					<Confirm
						confirmButton={t("ok")}
						cancelButton={t("cancel")}
						content={t("submitSurveyQuestion")}
						open={this.state.isOpenConfirmSubmit}
						onCancel={this.closeConfirmSubmit}
						onConfirm={() => this.submitData("submit", section.lang[this.props.activeLangCode])}
					/>
					<Form
						className="survey"
						style={{ overflowX: "auto", overflowY: "visible" }}
					>
					{section.lang["en"].charAt(1) === '.' && //ocajno ali radi za sada
					<Button
						icon
						className = {this.props.activeLangCode === "ar" ? "ui left floated button" : "ui right floated button"} 
						onClick={this.openConfirmSubmit}
						disabled={ 	!this.state.unsavedForm || 
							(this.props.loginData.type === userType.ADMIN && 
											!(selected && selected[0] && selected[0].search_id))  ||
							(this.props.loginData.type === userType.STANDARD &&
								this.props.surveyData.status ===
									surveyState.SIGNED) ||
							this.props.surveyData.status ===
								surveyState.APPROVED
						}
					>
						{t("submitSurvey")}{"    "}{section.lang[this.props.activeLangCode]}
						<Icon name={this.props.activeLangCode === "ar" ? "left chevron" : "right chevron"} />
					</Button>
					}						
						<DynamicForm
							parentKey={section.lang[this.props.activeLangCode]}
							form={section.fields}
							root={true}
							t={t}
							handleInput={this.handleInput}
							values={this.props.surveyData.mappedFields}
							schemaJsonMetamodel={schemaJsonMetamodel}
							loginData={this.props.loginData}
							activeLangCode={this.props.activeLangCode}
							disabled={
								(this.props.loginData.type === "S" &&
									this.props.surveyData.status ===
										surveyState.SIGNED) ||
								this.props.surveyData.status ===
									surveyState.APPROVED
							}
							paneName={section.lang[this.props.activeLangCode]}
							hideForm={this.props.hideForm}
						/>
					{section.lang["en"].charAt(1) === '.' && //ocajno ali radi za sada
					<Button
						icon
						className = {this.props.activeLangCode === "ar" ? "ui left floated button" : "ui right floated button"} 
						onClick={this.openConfirmSubmit}
						disabled={ 	!this.state.unsavedForm || 
							(this.props.loginData.type === userType.ADMIN && 
											!(selected && selected[0] && selected[0].search_id))  ||
							(this.props.loginData.type === userType.STANDARD &&
								this.props.surveyData.status ===
									surveyState.SIGNED) ||
							this.props.surveyData.status ===
								surveyState.APPROVED
						}
					>
						{t("submitSurvey")}{"    "}{section.lang[this.props.activeLangCode]}
						<Icon name={this.props.activeLangCode === "ar" ? "left chevron" : "right chevron"} />
					</Button>
					}											
					</Form>
				</Tab.Pane>
			)
		}));

		let selected = this.props.establishments.filter(x => x.selected);

		return (
			<div
				align={this.props.activeLangCode === "ar" ? "right" : "left"}
				dir={this.props.activeLangCode === "ar" ? "rtl" : "ltr"}
			>
				{this.props.loginData &&
					this.props.loginData.type === userType.STANDARD && (
						<SurveyInfoModal
							open={this.state.visibleSurveyModal}
							onClose={this.closeSurveyModal}
						/>
					)}
				<h1>{t("industrialStatisticsSurvey")}</h1>
				<h2>{t("sultanteOfOman")}</h2>
				<h3>{t("surveyYear")}{"  "}
					{
						this.props.selectedYear &&
						<Dropdown
							selection
							options={this.props.years &&
								this.props.years.map(x => ({
									key:
									x.year,
									value:
									x.year,
									text:
									x.year
								}))}

							onChange={this.selectedYearChanged}


							value={ this.props.selectedYear }

							search
							basic
							lazyLoad={true}
							className="no-border-radius"
						/>
					}
				</h3>

				{this.props.loginData.type === userType.ADMIN && (
					<EstablishmentsContainer
						unsavedForm={this.state.unsavedForm}
						unsavedFormClear={this.unsavedFormClear}
					/>
				)}

				{this.props.loginData.type === userType.ADMIN &&
					selected &&
					selected[0] &&
					selected[0].search_id && (
						<h2>
							{selected[0].search_id} -{" "}
							{this.props.activeLangCode === "ar"
								? this.props.surveyData.mappedFields["name"]
								: this.props.surveyData.mappedFields[
										"name_english"
								  ]}{" "}
						</h2>
					)}

				{this.props.loginData.type === userType.STANDARD &&
					this.props.loginData && (
						<h2>
							{this.props.activeLangCode === "ar"
								? this.props.surveyData.mappedFields["name"]
								: this.props.surveyData.mappedFields[
										"name_english"
								  ]}{" "}
						</h2>
					)}

				<div
					className="survey-toolbar"
					dir={this.props.activeLangCode === "ar" ? "rtl" : "ltr"}
				>
					{this.props.loginData.type === userType.STANDARD && (
						<React.Fragment>
							<Button
								onClick={this.openConfirmSign}
								disabled={ this.props.surveyData.status ===
										surveyState.SIGNED ||
									this.props.surveyData.status ===
										surveyState.APPROVED ||
										this.state.unsavedForm ||
									    this.props.hideForm
								}
							>
								{(this.props.surveyData.status !== surveyState.APPROVED && 
									this.props.surveyData.status !== surveyState.SIGNED && 
										this.state.unsavedForm) ? t("signAndRequestApprovalInactiveReason") : t("signAndRequestApproval")} 								
							</Button>
							<Confirm
								confirmButton={t("ok")}
								cancelButton={t("cancel")}
								content={t("signAndRequestApprovalQuestion")}
								open={this.state.isOpenConfirmSign}
								onCancel={this.closeConfirmSign}
								onConfirm={() => this.submitData("sign", null)}
							/>
						</React.Fragment>
					)}
					{this.props.loginData.type === userType.ADMIN && (
						<React.Fragment>
							<Button
								onClick={this.openConfirmApprove}
								disabled={ !(selected && selected[0] && selected[0].search_id)  ||
									this.props.surveyData.status ===
									surveyState.APPROVED ||
									this.state.unsavedForm || this.props.hideForm
								}
							>
								{this.props.surveyData.status !== surveyState.APPROVED && this.state.unsavedForm ? t("approveInactiveReason") : t("approve")} 
							</Button>
							<Confirm
								confirmButton={t("ok")}
								cancelButton={t("cancel")}
								content={t("approveQuestion")}
								open={this.state.isOpenConfirmApprove}
								onCancel={this.closeConfirmApprove}
								onConfirm={() => this.submitData("approve", null)}
							/>
						</React.Fragment>
					)}
					{this.props.loginData.type === userType.ADMIN && (
						<React.Fragment>
							<Button
								onClick={this.openConfirmReject}
								disabled={ !(selected && selected[0] && selected[0].search_id) ||
									!this.props.surveyData.email || this.props.surveyData.status === surveyState.APPROVED
								}
							>
								{t("reject")}
							</Button>
							<Modal open={this.state.isOpenConfirmReject}>
								<Modal.Header>
									{t("rejectQuestion")}
								</Modal.Header>
								<Modal.Content>
									<Form>
										<TextArea
											onChange={this.rejectReasonChanged}
											value={this.state.rejectReasonText}
											maxLength={2000}
											placeholder={t(
												"reasonForRejecting"
											)}
										/>
									</Form>
								</Modal.Content>
								<Modal.Actions>
									<Button onClick={this.closeConfirmReject}>
										{t("cancel")}
									</Button>
									<Button
										primary
										disabled={!this.state.rejectReasonText}
										onClick={this.rejectData}
									>
										{t("ok")}
									</Button>
								</Modal.Actions>
							</Modal>
						</React.Fragment>
					)}
					<Label.Group circular className="survey-toolbar-right">
						{this.props.surveyData &&
							this.props.surveyData.status ===
								surveyState.SIGNED && (
								<Label>
									{t("signedAt")}{" "}
									{moment(
										this.props.surveyData.modifiedAt,
										"YYYYMMDDhhmmss"
									).format("LLL")}
								</Label>
							)}
						{this.props.surveyData &&
							this.props.surveyData.status ===
								surveyState.APPROVED && (
								<Label color="green">
									<Icon name="check" />
									{t("approvedAt")}{" "}
									{moment(
										this.props.surveyData.modifiedAt,
										"YYYYMMDDhhmmss"
									).format("LLL")}
									{t("modifiedBy")}{" "}{this.props.surveyData.modifiedBy}
								</Label>
							)}
						{this.props.surveyData &&
							this.props.surveyData.message &&
							this.props.surveyData.status ===
								surveyState.REJECTED &&  !this.state.reasonMessageViewed  && (
								<Label pointing={this.props.activeLangCode === "ar" ? "left" : "right"}>{t("viewRejectMessage")}}</Label>								
							)}							
						{this.props.surveyData && 
							this.props.surveyData.message && (								
								<Label color={this.props.surveyData.status ===
									surveyState.REJECTED ? "red" : "blue"} onClick={() => {							
										this.setState({
													...this.state,
													message: this.props.surveyData.message,
													showMessage: this.props.surveyData.message,
													inforMessage: true,
													reasonMessageViewed : true });
								}			
									} >
									<Icon name="check" />
									{t("rejectedAt")}{" "}
									{moment(
										this.props.surveyData.modifiedAt,
										"YYYYMMDDhhmmss"
									).format("LLL")}
									{t("modifiedBy")}{" "}{this.props.surveyData.modifiedBy}
								</Label>
							)}
					</Label.Group>
				</div>

				<Divider horizontal />
				<Tab
					panes={panes}
					renderActiveOnly={true}
					menu={{
						attached: true,
						tabular: true,
						className: "wrapped"
					}}
				/>
				<Prompt
					when={this.state.unsavedForm}
					message={t("confirmLeave")}
				/>
				<MessageModal
					show={this.state.showMessage}
					onHide={this.closeMessageModal}
					message={this.state.message}
					negative={this.state.negativeMessage}
					positive={this.state.positiveMessage}
					warrning={this.state.warningMessage}
				/>
				<MessageModal
					show={this.props.hasErrorMessage}
					onHide={this.props.clearInfoAndErrorMessagesDispatch}
					message={t(this.props.error)}
					negative={true}
					positive={false}
					warrning={false}
				/>
				<MessageModal
					show={this.props.hasInfoMessage}
					onHide={this.props.clearInfoAndErrorMessagesDispatch}
					message={t(this.props.message)}
					negative={false}
					positive={true}
					warrning={false}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		years: state.dynamicSurveyReducer.years,
		selectedYear: state.dynamicSurveyReducer.selectedYear,
		loginData: state.loginReducer.loginData,
		surveyData: state.dynamicSurveyReducer.surveyData,
		establishments: state.establishmentsReducer.surveyEstablishments,
		activeLangCode: state.internationalizationReducer.activeLangCode,
		error: state.dynamicSurveyReducer.error,
		hasErrorMessage: state.dynamicSurveyReducer.hasErrorMessage,
		message: state.dynamicSurveyReducer.message,
		hasInfoMessage: state.dynamicSurveyReducer.hasInfoMessage,
		hideForm: state.dynamicSurveyReducer.hideForm
	};
};

const mapDispatchToProps = dispatch => {
	return {
		selectedYearChanged: year => {
			dispatch(selectNewYear(year));
		},
		getSurveyPeriods: () => {
			dispatch(getSurveyPeriods());
		},
		submitSurveyDataDispatch: (data, type) => {
			dispatch(submitSurveyData(data, type));
		},
		getSurveyDataDispatch: data => {
			dispatch(getSurveyData(data));
		},
		surveyDataUpdateDispatch: data => {
			dispatch(surveyDataUpdate(data));
		},
		clearInfoAndErrorMessagesDispatch: () => {
			dispatch(clearInfoAndErrorMessages());
		},
		dispatch: dispatch
	};
};

const DynamicSurveyContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DynamicSurveyComponent);

export default translate()(DynamicSurveyContainer);



// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/DynamicSurveyContainer.js